import { DailyLoginCalendarDay } from './dailyRewards.models';

import { CalendarDayVariant } from './components/CalendarDay';

import { CALENDAR_ROW_SIZE } from './constants';

export const mapDayToVariant = (day: DailyLoginCalendarDay): CalendarDayVariant => {
  if (!day.current_month) return 'otherMonth';
  if (day.claimed) return 'claimed';
  if (day.limit_reached && !day.claimed) return 'missed';
  if (day.claimable) return 'current';
  if (day.status === 'PAST_DATE' && !day.claimed) return 'missed';
  return 'upcoming';
};

/**
 * API always returns 42 days (6×7 grid). If the last row is entirely
 * other-month padding (e.g. Feb 2026 ends Sat → Mar 1 Sun finishes row 5,
 * row 6 is pure padding), trim it.
 */
export const trimTrailingOtherMonthRows = (days: DailyLoginCalendarDay[]): DailyLoginCalendarDay[] => {
  let end = days.length;

  while (end > CALENDAR_ROW_SIZE) {
    const row = days.slice(end - CALENDAR_ROW_SIZE, end);
    if (row.every((d) => !d.current_month)) {
      end -= CALENDAR_ROW_SIZE;
    } else {
      break;
    }
  }

  return end === days.length ? days : days.slice(0, end);
};

export const getCurrentUTCYear = (): number => new Date().getUTCFullYear();
export const getCurrentUTCMonth = (): number => new Date().getUTCMonth() + 1;

/**
 * Converts a UTC date string to a full ISO 8601 UTC timestamp.
 * Handles date-only format ("2026-02-26") by appending "T00:00:00Z".
 * Passes through strings that already have timezone info.
 */
export const toUTCTimestamp = (dateStr: string): string => {
  if (/[Zz]$/.test(dateStr) || /[+-]\d{2}:\d{2}$/.test(dateStr)) return dateStr;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return `${dateStr}T00:00:00Z`;
  return `${dateStr}Z`;
};
